module.exports = __webpack_public_path__ + "be0bb7c14b5fc8fe558fb8784faa8f42.pdf";